module.exports = __webpack_public_path__ + "img/rightSide@2x.edb53e8.webp";